/**
 * Generate CSS rules from Background Control attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { applyFilters } from '@wordpress/hooks';

import { BackgroundValues } from '../types';

/**
 * Generate background CSS rules from background values
 */
export const generateBackgroundCSSRules = (
	values: BackgroundValues,
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Background color - basic feature available in free version
	if ( values.backgroundColor ) {
		styles[ 'background-color' ] = values.backgroundColor;
	}

	// Premium features (image, gradient, pattern, overlay positioning) are handled via filter hooks.
	// The Pro plugin will extend these rules through the filter system.

	/**
	 * Filter background CSS rules
	 *
	 * Allows modification of generated background CSS rules
	 *
	 * @since 1.0.0
	 *
	 * @param {Record<string, string>} styles - Generated CSS rules
	 * @param {BackgroundValues} values - Background control values
	 */
	return applyFilters(
		'redfox_thank_you.background.css_rules',
		styles,
		values,
	) as Record< string, string >;
};

/**
 * Generate background overlay CSS rules from background values
 * These styles are applied to the .background-overlay element
 * Premium features are handled via Pro plugin filters
 */
export const generateBackgroundOverlayRules = (
	values: BackgroundValues,
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Premium overlay features are handled via filter hooks.
	// The Pro plugin will extend these rules through the filter system.

	/**
	 * Filter background overlay CSS rules
	 *
	 * Allows modification of generated background overlay CSS rules
	 *
	 * @since 1.0.0
	 *
	 * @param {Record<string, string>} styles - Generated CSS rules
	 * @param {BackgroundValues} values - Background control values
	 */
	return applyFilters(
		'redfox_thank_you.background.overlay_css_rules',
		styles,
		values,
	) as Record< string, string >;
};
